// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu[data-v-b1a03022]{background:#fff;padding:65px 16px 90px}.menu__position[data-v-b1a03022]{position:relative;z-index:51}.menu__header[data-v-b1a03022]{background:#fff;left:0;position:fixed;top:0;width:100%;z-index:3}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
